// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2t6Je","title":"Header_title__XruNr","nav":"Header_nav__akIpU","link":"Header_link__3VU1J"};